import React from 'react'

import Head from 'next/head'
import Link from 'next/link'

import Footer from '~/components/Footer'
import { TopNavigation } from '~/components/TopNav'
import { useGetUserQuery } from '~/graphql/generated/schema'
import useLocalDate from '~/hooks/useLocalDate'
import useLocale from '~/hooks/useLocale'
import { useCommonTx } from '~/hooks/useTranslationForNamespace'
import AppStoreBadge from '~/images/MobileApps/app-store-badge.svg'
import GooglePlayBadge from '~/images/MobileApps/google-play-badge.svg'

const MobileDevicesInterstitial = (): JSX.Element => {
  const t = useCommonTx('common.interstitials.mobileDevices')
  const { dateFormatted } = useLocalDate()
  const { minNumberOfGamesForLocale } = useLocale()
  const { data: userQueryData } = useGetUserQuery()
  const name = userQueryData?.me?.firstName
  const greeting = t(`greeting`, { name: name })
  const isAndroidOS = navigator.userAgent.match(/Android/i)
  const isIOS = navigator.userAgent.match(/iPhone|iPad|iPod/i)
  const isUnknownOS = !isAndroidOS && !isIOS
  const showGooglePlayStoreLink = isAndroidOS || isUnknownOS
  const showAppleAppStoreLink = isIOS || isUnknownOS

  return (
    <>
      <Head>
        <title>{t('title')}</title>
      </Head>
      <TopNavigation />
      <div className='my-[48px] mx-[32px] flex flex-col justify-center items-start text-left'>
        <div className='text-body-text-2'>{dateFormatted}</div>
        <div className='text-heading-2 mb-6'>{greeting}</div>
        <div className='text-heading-3'>{t('header')}</div>
        <div className='flex flex-row gap-4'>
          {showGooglePlayStoreLink && (
            <div className='w-[150px] cursor-pointer'>
              {/*TODO: localize the SVG for all marketplaces */}
              <Link href='https://play.google.com/store/apps/details?id=com.lumoslabs.lumosity' passHref={true}>
                <GooglePlayBadge title='google-play-badge' width='100%' height='100%' />
              </Link>
            </div>
          )}
          {showAppleAppStoreLink && (
            <div className='w-[150px] cursor-pointer'>
              {/*TODO: localize the SVG for all marketplaces */}
              <Link href='https://apps.apple.com/app/lumosity-brain-training/id577232024' passHref={true}>
                <AppStoreBadge title='app-store-badge' width='100%' height='100%' />
              </Link>
            </div>
          )}
        </div>
        <div
          className='w-full aspect-[1/1] max-w-[640px]'
          style={{
            backgroundImage: 'url(/assets/images/mobile-apps.png)',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          }}
        />
        <div className='text-body-text-1'>{t('body', { minNumberOfGames: minNumberOfGamesForLocale })}</div>
      </div>
      <Footer />
    </>
  )
}

export default MobileDevicesInterstitial
